"use client";

import { Loader2 } from "lucide-react";
import "./components.css";

export default function Spinner() {
  return <Loader2 className="spinner" />;
}
